// extracted by mini-css-extract-plugin
export default {"logo":"Home_logo__B2tGQ"};